import { useQuery } from '@tanstack/react-query';
import { fetchAgreementPrices, fetchAgreements } from "./endpoints";
import { mergeAgreementsWithPrices } from "../helpers";
export const useAgreements = (customerId) => {
    var _a, _b, _c;
    const { data: agreements, isLoading, isFetching, isError, error, refetch, } = useQuery({
        queryKey: ['agreements', customerId],
        queryFn: async () => {
            const [agreementsResult, priceResult] = await Promise.all([
                fetchAgreements(customerId),
                fetchAgreementPrices(customerId),
            ]);
            return mergeAgreementsWithPrices(agreementsResult, priceResult);
        },
        enabled: !!customerId,
    });
    const agreementsErrorMessage = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data.message) || ((_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.title) || '';
    return {
        agreements,
        isLoading,
        isFetching,
        isError,
        agreementsErrorMessage,
        refetch,
    };
};
